export default "__VITE_ASSET__DBbiKhF___"